export interface Product {
  id: string
  images: string[]
  name: string
  title?: string
  subtitle?: string
  description?: Array<string>
  variants?: Array<Variant>
  weight?: number
  length?: number
  size?: string
  color?: string
  category: Category
  price: number
}

export enum Category {
  LURE = 'Lure',
  SWAG = 'Swag',
  GEAR = 'Gear',
}

export interface Variant {
   id: string,
   name: string
}
